export default {"src":"/_next/static/media/flagIconHover.47e105ff.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};